import { Box, Container, Link, Stack, Typography } from '@mui/material';
import React, { FC } from 'react';
import ScrollToTop from '../../../components/layout/ScrollToTop';

const Impressum: FC<{}> = () => {
	return (
		<>
			<ScrollToTop />
			<Container>
				<Stack spacing={2}>
					<Typography variant="h2" component="h1">
						Impressum
					</Typography>
					<br />

					<Typography variant="h4" component="h3">
						Verband der Musik- und Kunstschulen Brandenburg e.V.
						<br />
						Schiffbauergasse 4 b
						<br />
						14467 Potsdam
					</Typography>
					<Box>

						<Typography>
							Telefon: +49 331 20 16 47 0
						</Typography>
						<Typography>
							Telefax: +49 331 20 16 47 29
						</Typography>
						<Typography>
							E-Mail: <Link href={'mailto:kontakt@vdmk-brandenburg.de'}>kontakt@vdmk-brandenburg.de</Link>
						</Typography>
						<Typography>
							Internet: <Link href={'https://vdmk-brandenburg.de/'}> https://vdmk-brandenburg.de/</Link>
						</Typography>
					</Box>
					<Box>
						<Typography>
							Vertretungsberechtigter Vorstand: Gerrit Große (Vorsitzende)
						</Typography>
						<Typography>
							Registergericht: Amtsgericht Potsdam
						</Typography>
						<Typography>
							Registernummer: VR 1779 P
						</Typography>
						<Typography>
							USt-ID: DE271387219
						</Typography>
					</Box>
					<Box>
						<Typography>
							Haftungshinweis: Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung für die Inhalte externer Links. Für den Inhalt der verlinkten Seiten sind ausschließlich deren Betreiber verantwortlich.
						</Typography>
						<Typography>
							Technische Umsetzung:  B & IT Services
						</Typography>
						
					</Box>
				</Stack>
			</Container>
		</>
	);
};
export default Impressum;
